<div class="category-list">
    <div *ngIf="loading" class="loading-skeleton">
        <app-skeleton-loader *ngFor="let i of [1, 2, 3]" height="72px" borderRadius="12px"></app-skeleton-loader>
    </div>

    <div *ngIf="!loading && categories.length === 0" class="empty-state">
        {{ 'permit.config.categories.empty' | translate }}
    </div>

    <div class="category-card" *ngFor="let category of categories">
        <div class="category-header">
            <div class="category-icon">
                <span [ngClass]="category.icon || 'icon-folder'"></span>
            </div>
            <div class="category-title">{{ i18nName(category.name) }}</div>

            <!-- Category active toggle -->
            <span class="category-active" (click)="$event.stopPropagation()">
                <app-form-toggle
                    [checked]="category.active"
                    (change)="toggleCategoryActive(category, $event)"
                ></app-form-toggle>
            </span>

            <!-- Kebab menu -->
            <div class="category-actions">
                <button mat-icon-button [matMenuTriggerFor]="categoryMenu" class="more-button">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #categoryMenu="matMenu">
                    <button mat-menu-item (click)="onEditCategory(category)">
                        <span>{{ 'permit.config.common.edit' | translate }}</span>
                    </button>
                    <button mat-menu-item (click)="confirmDeleteCategory(category)">
                        <span>{{ 'permit.config.common.delete' | translate }}</span>
                    </button>
                </mat-menu>
            </div>
        </div>

        <div class="category-content">
            <div *ngIf="typesLoading[category._id]" class="types-loading-skeleton">
                <app-skeleton-loader *ngFor="let i of [1, 2, 3]" height="40px"></app-skeleton-loader>
            </div>

            <ng-container *ngIf="!typesLoading[category._id]">
                <div *ngIf="!(typesByCategory[category._id] || []).length" class="empty-types">
                    {{ 'permit.config.categories.types_empty' | translate }}
                </div>

                <div class="subcategory-details-grid" *ngIf="(typesByCategory[category._id] || []).length > 0">
                    <!-- Header row -->
                    <div class="type-grid-header">
                        <div class="grid-header">{{ 'permit.config.categories.col_type' | translate }}</div>
                        <div class="grid-header">{{ 'permit.config.categories.col_prefix' | translate }}</div>
                        <div class="grid-header">{{ 'permit.config.categories.col_department' | translate }}</div>
                        <div class="grid-header">{{ 'permit.config.categories.col_active' | translate }}</div>
                    </div>

                    <!-- Type rows -->
                    <div
                        class="type-grid-row"
                        *ngFor="let type of typesByCategory[category._id]"
                        (click)="onEditType(category, type)"
                    >
                        <div class="grid-cell type-name-cell">
                            {{ i18nName(type.name) }}
                        </div>
                        <div class="grid-cell prefix-cell">
                            <span class="prefix-chip" *ngIf="type.numberPrefix">{{ type.numberPrefix }}</span>
                            <span *ngIf="!type.numberPrefix" class="empty-val">—</span>
                        </div>
                        <div class="grid-cell dept-cell">
                            <span *ngIf="departmentName(type)">{{ departmentName(type) }}</span>
                            <span *ngIf="!departmentName(type)" class="empty-val">—</span>
                        </div>
                        <div class="grid-cell active-cell" (click)="$event.stopPropagation()">
                            <app-form-toggle
                                [checked]="type.active"
                                (change)="toggleTypeActive(category, type, $event)"
                            ></app-form-toggle>
                        </div>
                    </div>
                </div>

                <!-- Add type pill -->
                <button
                    type="button"
                    mat-stroked-button
                    class="add-type-btn"
                    (click)="onAddType(category)"
                >
                    <mat-icon>add</mat-icon>
                    {{ 'permit.config.categories.add_type' | translate }}
                </button>
            </ng-container>
        </div>
    </div>
</div>
